/* eslint-disable */
// Here eslint disable is use to avoid line width error
import React from "react";

const Bell = (props: { className?: string }) => (
  <svg {...props} xmlns="http://www.w3.org/2000/svg" width="18" height="19.5" viewBox="0 0 18 19.5">
    <path
      id="Tracé_6339"
      data-name="Tracé 6339"
      d="M20,18.326H2V16.512h.9V10.191a8.1,8.1,0,1,1,16.2,0v6.321H20ZM4.7,16.512H17.3V10.191a6.3,6.3,0,1,0-12.6,0Zm4.05,2.721h4.5a2.25,2.25,0,1,1-4.5,0Z"
      transform="translate(-2 -2)"
      fill="currentColor"
    />
  </svg>
);

export { Bell };
